module.exports = __webpack_public_path__ + "static/media/wbg.8181e656.png";